// extracted by mini-css-extract-plugin
module.exports = {"labelText":"_3jPv2___labels-module__labelText"};